module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-house-81eda40037cc1df284b60d946ff8a4f2.svg";